import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { MarketingApiAdapter } from '../adapters';
import { MarketingApiResponse, MarketingFilters } from '../models';

interface UseMarketingDataProps {
  filters?: MarketingFilters;
  enabled?: boolean;
}

export const useMarketingData = ({ filters, enabled = true }: UseMarketingDataProps = {}) => {
  const adapter = new MarketingApiAdapter(createHttpClient(apiClientWH));

  // Only enable if we have actual filters or it's explicitly enabled
  const shouldFetch = enabled && filters && Object.keys(filters).length > 0;

  const query = useQuery<MarketingApiResponse, Error>({
    queryKey: ['marketing-report', filters],
    queryFn: () => adapter.getMarketingReport(filters),
    enabled: shouldFetch,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      if (error?.message?.includes('401') || error?.message?.includes('403')) {
        return false;
      }
      return failureCount < 3;
    },
  });

  return {
    marketingData: query.data,
    segments: query.data?.segments || [],
    meta: query.data?.meta,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error?.message || null,
    refetch: query.refetch,
  };
};
